/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_mobile_analytics_app_id": "0234fafc410b4d00aa8c0d61aab5d558",
    "aws_mobile_analytics_app_region": "eu-west-2",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "0234fafc410b4d00aa8c0d61aab5d558",
            "region": "eu-west-2"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://ktyklgvawvfphp3kaq22qgvkzi.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-eek4kjvq2nal3kgltj2nra47be",
    "aws_cognito_identity_pool_id": "eu-west-2:22c5d25a-1ac1-4355-969a-7998ba638102",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_f6TbrO1jC",
    "aws_user_pools_web_client_id": "152gt3ilk79j0gacbt41dljgnk",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GENDER",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
